import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Link,
} from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { useDispatch } from "react-redux";
import { BASE_URL } from "./variables/api";
import Swal from "sweetalert2";
import Layout from "./Layout";
import { setPermissions } from "./store/actions/auth.actions";
import jwt_decode from "jwt-decode";
import { IStateType } from "./store/models/root.interface";
import { useSelector } from "react-redux";
import Header from "./Components/Header";
import "./App.css";
import Stack from "./Components/Stack";
import { Avatar } from "@mui/material";
import Addticket from "./views/Addticket/addticket";
import Viewticket from "./views/Viewticket/Viewticket";
import img from "./assets/ivy_logo.png";

import "./assets/css/material-dashboard-react.css?v=1.6.0";
import { useNavigate } from "react-router-dom";
import Departmentticket from "./views/DepartmentTickets/Departmenticket";
import ViewDepartmentTicket from "./views/ViewDepartmentTicket/ViewDepartmentTicket";
import Admintab from "./views/Admintab/Admintab";
import EmployeeConfig from "./views/Admintab/EmployeeConfig";
import DepartmentConfig from "./views/Admintab/DepartmentConfig";
import Other from "./views/Addticket/AddTicketForOtherUser";
import { unstable_createChainedFunction } from "@mui/utils";
axios.defaults.withCredentials = true;

const App: React.FC = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const permissions = useSelector((state: IStateType) => state.permissions);
  const [user, setUser] = useState<any>();
  const [departmentId, setDepartmentId] = useState("");
  const [departments, setDepartments] = useState([]);
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [email, setEmail] = useState<string>("");
  const [isAuth, setIsAuth] = useState("0");
  const [info, setInfo] = useState(false);

  const staffPortal = () => {
    let decodedToken: any = {};
    try {
      axios
        .post(`${BASE_URL}/auth/login.php`)
        .then((response: any) => {
          //logging.info(response.data.user, 'SAML');
          setUser((prevstate: any) => ({
            ...prevstate,
            username: response.data.data.user.displayname,
            driveid: response.data.data.employee.driveid,
            role_id: response.data.data.user.role_id,
          }));
          axios
            .get(`${BASE_URL}/auth/getuserandemployeeinupdateroles.php`)
            .then((data) => {
              setUser((prevstate: any) => ({
                ...prevstate,
                username: data.data.data?.user?.displayname,
                employee: data.data.data?.employee?.driveid,
                role_id: data.data.data?.user?.role_id,
              }));
              if (user?.username === undefined) {
                setInfo(!info);
              }
              setDepartmentId(
                data.data.data?.employeedepartments[0]?.department_ids
              );
              setStatus(data.data.data?.status);
              setDepartments(data.data.data?.departments);
            })
            .catch((e) => {
              let ee = e as any;
              console.log(ee, "error");
              Swal.fire(
                ee?.response?.data.error || "Failed to Connect Please refresh",
                "",
                "error"
              );
            });

          if (response.data.data?.token) {
            setIsAuth("1");
            const token = response.data.data?.token;
            Cookies.set("tickettoken", token, {
              sameSite: "none",
              secure: true,
            });
            decodedToken = jwt_decode(token);

            dispatch(
              setPermissions({ ...decodedToken.data.user, isAuth: "1" })
            );
            setEmail(response.data.user);
            setLoading(false);
          } else {
            // RedirectToLogin();
          }
        })
        .catch((error) => {
          // RedirectToLogin();
        });
    } catch (e) {
      let ee = e as any;
      console.log(ee, "error");
      Swal.fire(ee?.response?.data.error || "Failed to login", "", "error");
    }
  };

  const guardianPortal = () => {
    try {
      setIsAuth("1");
      axios
        .get(`${BASE_URL}/auth/getuserandemployeeinupdateroles.php`)
        .then((data) => {
          if (data.data.data.employee) {
            setUser((prevstate: any) => ({
              ...prevstate,
              username: data.data.data.user.displayname,
              driveid: data.data.data.employee.driveid,
              role_id: data.data.data.user.role_id,
            }));
            setDepartmentId(
              data.data.data.employeedepartments[0]?.department_ids
            );
            setStatus(data.data.data.status);
            setDepartments(data.data.data.departments);
          } else {
            setUser((prevstate: any) => ({
              ...prevstate,
              username: data.data.data.user.displayname,
              role_id: data.data.data.user.role_id,
            }));
            setDepartmentId('["0"]');
            setStatus(data.data.data.status);
            setDepartments(data.data.data.departments);
          }
        })
        .catch((e) => {
          let ee = e as any;
          Swal.fire(
            ee?.response?.data.msg || "Failed to Connect Please refresh",
            "",
            "error"
          );
        });
    } catch (e) {
      let ee = e as any;

      Swal.fire(ee?.response?.data.msg || "Failed to login", "", "error");
    }
  };
  const normallogin = () => {
    try {
      setIsAuth("1");
      axios
        .get(`${BASE_URL}/auth/getuserandemployeeinupdateroles.php`)
        .then((data) => {
          if (data.data.data.employee) {
            setUser((prevstate: any) => ({
              ...prevstate,
              username: data.data.data.user.displayname,
              driveid: data.data.data.employee.driveid,
              role_id: data.data.data.user.role_id,
            }));
            setDepartmentId(
              data.data.data.employeedepartments[0]?.department_ids
            );
            setStatus(data.data.data.status);
            setDepartments(data.data.data.departments);
          } else {
            setUser((prevstate: any) => ({
              ...prevstate,
              username: data.data.data.user.displayname,
              role_id: data.data.data.user.role_id,
            }));
            setDepartmentId('["0"]');
            setStatus(data.data.data.status);
            setDepartments(data.data.data.departments);
          }
        })
        .catch((e) => {
          let ee = e as any;
          Swal.fire(
            ee?.response?.data.msg || "Failed to Connect Please refresh",
            "",
            "error"
          );
        });
    } catch (e) {
      let ee = e as any;

      Swal.fire(ee?.response?.data.msg || "Failed to login", "", "error");
    }
  };
  useEffect(() => {
    let dashboard = window.location.href;
    if (dashboard.search("https://staff.ivyis.org") != -1) {
      const portaltoken = Cookies.get("portaltoken");
      if (portaltoken) {
        staffPortal();
      } else {
        window.location.replace("https://staff.ivyis.org");
      }
    } else if (dashboard.search("https://guardian.ivyis.org") != -1) {
      const guardiantoken = Cookies.get("guardiantoken");
      if (guardiantoken) {
        guardianPortal();
      } else {
        window.location.replace("https://guardian.ivyis.org");
      }
    } else {
      normallogin();
    }
  }, []);

  const ChangeClassesTab = (active: any, unactive1: any, unactive2: any) => {
    var element = document.getElementById(active);
    element?.classList.add("active");
    element = document.getElementById(unactive1);
    element?.classList.remove("active");
    element = document.getElementById(unactive2);
    element?.classList.remove("active");
  };
  return (
    <>
      {permissions.isAuth === "1" || isAuth === "1" ? (
        <>
          <Header>
            <Link to="/">
              <img className="logo" src={img} alt="ivylogo" />
            </Link>
            <Stack>
              <span className="span">
                {user?.username === undefined
                  ? `Welcome,`
                  : `Welcome,${user?.username}`}
              </span>
              {user?.driveid ? (
                <Avatar
                  style={{ marginRight: "14px" }}
                  alt={`${user?.username}`}
                  src={`https://drive.google.com/uc?id=${user?.driveid}&export=download`}
                />
              ) : (
                <Avatar
                  style={{ marginRight: "14px" }}
                  alt={`${user?.username}`}
                />
              )}
            </Stack>
          </Header>
          <div style={{ width: "90%", marginLeft: "5%", marginTop: "2%" }}>
            <nav
              style={{ textAlign: "center" }}
              className="nav nav-tabs flex-column flex-sm-row"
            >
              <button
                className="flex-sm-fill text-sm-center nav-link active"
                id="ticket"
                style={{ border: "1px solid" }}
                aria-current="page"
                onClick={() => {
                  navigate("/");
                  ChangeClassesTab("ticket", "admintab", "department");
                }}
              >
                {user?.role_id === "1" ? "Tickets" : "My Tickets"}
              </button>
              {user?.role_id === "1" ? (
                <button
                  className="flex-sm-fill text-sm-center nav-link "
                  id="admintab"
                  style={{ border: "1px solid" }}
                  onClick={() => {
                    navigate("/admin-tab");
                    ChangeClassesTab("admintab", "ticket", "department");
                  }}
                >
                  Admin Tab
                </button>
              ) : null}
              {user?.role_id !== "3" && user ? (
                <button
                  className="flex-sm-fill text-sm-center nav-link "
                  id="department"
                  style={{ border: "1px solid" }}
                  onClick={() => {
                    navigate(`/department`);
                    ChangeClassesTab("department", "admintab", "ticket");
                  }}
                >
                  Department
                </button>
              ) : null}
            </nav>
            <Routes>
              <Route
                path="/"
                element={<Layout user={user} departmentId={departmentId} />}
              />
              <Route
                path="/ticket"
                element={<Addticket user={user} departmentId={departmentId} />}
              />
              <Route
                path="/ticket/other"
                element={<Other user={user} departmentId={departmentId} />}
              />
              <Route
                path="/ticket/:id"
                element={<Viewticket user={user} departmentId={departmentId} />}
              />
              <Route
                path="/departmentticket/:id"
                element={
                  <ViewDepartmentTicket
                    user={user}
                    departmentId={departmentId}
                    status={status}
                    departments={departments}
                  />
                }
              />
              <Route
                path="/department"
                element={
                  <Departmentticket user={user} departmentId={departmentId} />
                }
              />
              <Route
                path="/admin-tab"
                element={
                  <Admintab
                    departments={departments}
                    user={user}
                    departmentId={departmentId}
                  />
                }
              />
              <Route
                path="/config"
                element={<EmployeeConfig config={"config"} />}
              />
              <Route path="/configdept" element={<DepartmentConfig />} />
            </Routes>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/" element={<h2>404 Page Not Found</h2>} />
        </Routes>
      )}
    </>
  );
};

export default App;
